import { Component, OnInit, AfterViewInit, Inject, ViewChild, ElementRef, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-countrymap',
  templateUrl: './countrymap.component.html',
  styleUrls: ['./countrymap.component.less']
})
export class CountrymapComponent implements OnInit, AfterViewInit {

  mapId: number = 0;
  mapTitle: string = '';
  public isLocal: boolean = true;
  isIE: boolean = false;
  screenWidth: number = 0;

  constructor(private dialogRef: MatDialogRef<CountrymapComponent>,
    @Inject(MAT_DIALOG_DATA) private data: number) { }

  ngOnInit() {
    this.isIE = /*@cc_on!@*/false || !!document.documentMode;
    this.screenWidth = window.innerWidth;

    this.mapId = this.data;
    this.mapTitle = this.mapId == 1 ? 'South African Student' : this.mapId == 2 ? 
      'Non South African ID Holders' : 'Overseas International Student';
  }

  @ViewChild('countries', {static:false}) mapElement: ElementRef;
  ngAfterViewInit() {
    if(this.isIE == false){
      console.log('Map part executed');

      var d3WithGeo = window["d3"];
      var map : any;

      map = d3WithGeo.geomap.choropleth()
        .geofile('/assets/topojson/world/countries.json')
        .colors(['#008000', '#90ee90', '#00FFFF'])
        .column('regionid')
        .width(this.mapElement.nativeElement.offsetHeight * 1.5)
        .unitId('iso3');

      d3WithGeo.csv('assets/data/geo.csv', function(error, data) {
        var selection = d3WithGeo.select('#map').datum(data);
        map.draw(selection);
      });
    } else {
      console.log('Map part NOT executed')
    }
  }
  
  onClose() {
    this.dialogRef.close();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.screenWidth = window.innerWidth;
  }
}
